import { inject, Injectable } from '@angular/core';
import { TransportDetailNavigationService } from '@myarvato/core/services';
import { AuthorizationService } from '@myarvato/core/authentication';
import { MyArvatoEnvironment } from '@myarvato/shared/models';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TrackingDetailsStore } from '@myarvato/modules/transport/services';
import { TrackingDetailsDialogComponent } from '@myarvato/modules/transport/details';
import { TranslateService } from '@ngx-translate/core';
import { MyArvatoDialogService } from '@myarvato/shared/dialog';

@Injectable({
  providedIn: 'root',
})
export class TransportDetailNavigationServiceImplementation extends TransportDetailNavigationService {
  private readonly authorizationService = inject(AuthorizationService);
  private readonly detailsStore = inject(TrackingDetailsStore);
  private readonly dialogService = inject(MyArvatoDialogService);
  private readonly environment = inject(MyArvatoEnvironment);
  private readonly httpClient = inject(HttpClient);
  private readonly translateService = inject(TranslateService);

  private readonly transportIdUrl = `${this.environment.url.api}Transport/ByTrackingNumber/Id`;

  public override mayOpenModule(): boolean {
    return this.authorizationService.hasModules(['transport']);
  }

  public override async openViaTrackingNumber(trackingNumber: string, ehGuid?: string, arvatoDeliveryNumber?: string): Promise<void> {
    this.detailsStore.setSelectedItem({
      trackingNumber,
      ehGuid: ehGuid ?? (await this.getTransportGuid(trackingNumber, arvatoDeliveryNumber)),
    });

    this.dialogService.showDialog(TrackingDetailsDialogComponent, {
      size: 'xxl',
      header: this.translateService.instant('pages.transport.detail-page.parcel-details', { trackingNumber }),
    });
  }

  public async getTransportGuid(trackingNumber: string, arvatoDeliveryNumber?: string): Promise<string> {
    const request = this.httpClient.post<{ ehGuid: string }>(this.transportIdUrl, {
      trackingNumber,
      arvatoDeliveryNumber,
    });
    const result = await firstValueFrom(request);
    return result.ehGuid;
  }
}
